import { Container } from '../../../odie';

import { app } from '../../app';
import { WobbleAnimation } from '../../animations/WobbleAnimation';
import { BlockEntity } from '../../entities/BlockEntity';
import { mapGetPan } from '../../util/mapTools';
import { IEffect } from './IEffect';

/*
    invalid effect. for tapped blocks that cant produce any other effect.
*/
export class InvalidEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _entity: BlockEntity;
  private readonly _view: Container;

  // init
  //-------------------------------------------------------------------------
  constructor(entity: BlockEntity, view?: Container) {
    this._entity = entity;
    this._view = view ?? (entity.c.view2d.view.getChildAt(0) as Container);
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    // play sound
    app.sound.play('puzzle-invalid', {
      pan: mapGetPan(this._entity.c.position.mapPosition),
    });

    // wobble the entity view. dont block on animation
    new WobbleAnimation({
      target: this._view,
    }).start();
  }
}
